import Vue from 'vue';
import VueRouter from 'vue-router';
import LocationTrace from '../view/LocationTrace/index.vue';
import VideoPlay from '../view/VideoPlay/index.vue';
import swiper from '../view/swiper/index.vue';
import Home from '../view/Home.vue';
import VideoPage from '../view/LocationTrace/video.vue';
import RecVideo from '../view/LocationTrace/rec_video.vue';
import Platform from '../view/Platform/index.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/location-trace',
        name: 'LocationTrace',
        component: LocationTrace
    },
    {
        path: '/video-play',
        name: 'VideoPlay',
        component: VideoPlay
    },
    {
        path: '/swiper',
        name: 'swiper',
        component: swiper
    },
    {
        path: '/test-video',
        name: 'VideoPage',
        component: VideoPage
    },
    {
        path: '/test-rec-video',
        name: 'RecVideo',
        component: RecVideo
    },
    {
        path: '/platform',
        name: 'Platform',
        component: Platform
    }
    // 其他路由配置
];

const router = new VueRouter({
    mode: 'hash', // 使用 HTML5 History 模式
    routes
});

export default router;